console.log("WSA custom product");

$('#svg-group-select').change(function () {
	// window.location = '#' + $(this).val();

	var divElem = document.getElementById('fig-list');
	var chElem = document.getElementById($(this).val());
	var topPos = divElem.offsetTop;
	divElem.scrollTop = chElem.offsetTop-topPos;
});
var barW = $('#hang-bar img').width();
var contentW = $('#content-line').outerWidth();
/*set bar width*/
var barImageWidthCm = [35, 45, 60, 75];
/*set bar width in px*/
var barImageWidth = [445, 640, 835, 1070];
var barWidthHeightNewValues = {35:[8], 45:[8], 60:[11],75:[115]};
var barWidthHeightValues = {35:[8], 45:[8], 60:[8,11],75:[8,11,115]};
var barImgageWidthRatio = {'one-five': 100, 'two': 129, 'two-five': 165, 'three': 182};
var barImgageWidthRatioValue = {'one-five': 325, 'two': 5, 'two-five': 625, 'three': 75};

// WSA 
var barValueByNumber = {1:[44], 2:[45], 3:[46]};
// var heightClassByHeight ={39:'one-five', 40:'two', 41:'two-five'};
var heightClassByWidth ={35:'one-five', 45:'two', 60:'two-five', 75:'three'};
var barWidthValues = {35:[33], 45:[42], 60:[43],75:[48]};

function displaySelectedUM(elementId, value){
  // Always render centimetres. Conversion to inches is handled globally by
  // snippets/vh-unit-switch.liquid, which rewrites the visible text. The old
  // jQuery cookie read here was dead: nothing has written that cookie since
  // cm-convert was removed, so it always fell through to this branch anyway.
  $(elementId).html(value + " cm");
}
function rebuildOptionsDescription(){
    var optionTA = $('#options');
  	var descr = "";
	$('.fig-added').each(function(){
		if($(this).hasClass('text')){
			var id = $(this).attr('id').replace('text', '');	

			var txt = $('#txtItem'+id).val();
			var style = $('.txtStyle'+id).val();
          
         	descr += "Text: "+txt+" * Style: "+style+" -- \n";
		} else {
			var id = $(this).attr('id').replace('fig', '');
          	var imgName = $('.imgTag'+id).find("img:first").attr("title");

    	    descr += "Figure: "+imgName+" -- \n";
		}
	});
  
    optionTA.val(descr);	

  	var data_options = {};
    var i=0;
    $('.fig-added').each(function(){
      if($(this).hasClass('fig')){
        var id = $(this).attr('id');

				id = id.replace('fig', '');
        var imgName = $('.imgTag'+id).find("img:first").attr("title");
        var prop = ['img', id, 'https:'+$('#imgValue'+id).val(), imgName];
        data_options[i] = prop;
      } else {
        var id = $(this).attr('id');
        id = id.replace('text', '');
        var prop = ['text', id, $('#txtItem'+id).val(), $('#txtStyle'+id).val()];
        data_options[i] = prop;
      }
      i++;
    });
  	$("#data_options").val(JSON.stringify(data_options));
    var design = $(".medalP").clone();
    var hbar = design.find("#hang-bar");
    design.find("#forprint-img-svg").html(hbar.html());
    hbar.html("");
  	$("#data_image").val(design.html());
    $("#data_width").val( localStorage.getItem('selectedWidth'));
    $("#data_bars").val( localStorage.getItem('selectedBars'));  
}

// CUSTOM MEDAL - counter for added elements - must be set to max counter after reload
var figcnt = 0;

function rebuildTop(){
	var displayAlert = false;
	$('#content-line').html('');
  
	var selectedWidth = localStorage.getItem('selectedWidth');
	var countWidth = 0;
	
	/* refresh local storage */
	var addedElems = new Array();
	var maxWidth = $('#_optionHolder').outerWidth();
	var tooManyElems = false;
  	
 	var heightClass = localStorage.getItem('heightClass');

	 $('.fig-added').each(function(){
      var content = "";
      var id = 0;
      if($(this).hasClass('text')){
				id = $(this).attr('id').replace('text', '');
				
				var txt = $('#txtItem'+id).val();
        var style = $('.txtStyle'+id).val();
				content = '<span class="text-block '+heightClass+' '+style+' item'+id+' viewItem itemRemove'+id+'">'+txt+'</span>';
				addedElems.push(textElement(id, txt, style));
      } else {
        id = $(this).attr('id').replace('fig', '');
        var image = $('.imgTag'+id).html();	
        content = '<span class="figure-block '+heightClass+' item'+id+' viewItem itemRemove'+id+'">'+image+'</span>';
				addedElems.push($(this).prop('outerHTML'));
      }
      if(figcnt<id){ figcnt=id; }

      $('#one-fig-len').append(content);
      var figWidth = $('#one-fig-len').outerWidth();
      $('#one-fig-len').html('');
      
      if(countWidth + figWidth < maxWidth){
				$('#content-line').append(content);
				$(this).removeClass('warning');
      }
      else {
        tooManyElems = true;
        $(this).addClass('warning');
      }
      countWidth += figWidth;
	});
	localStorage.setItem("addedElems", JSON.stringify(addedElems));
	
	if(tooManyElems){
		// increase width if possible
		var intW = parseInt(selectedWidth);
		if(intW<75){
			var idx = barImageWidthCm.indexOf(intW);
			console.log("idx="+idx+" next: "+barImageWidthCm[idx+1]);
	$('.single-option-selector:eq(0)').val(barImageWidthCm[idx+1]).trigger('change');
			return;
		}
		displayAlert = true;
	}  

	if(displayAlert == true){
		console.warn('Options oversize!');
		$('.overflow-msg').show();
				$("#product-add-to-cart").addClass("disabled");
				$("#quantity").addClass("disabled");
	} 
    else {
		$('.overflow-msg').hide();
      	$("#product-add-to-cart").removeClass("disabled");
				$("#quantity").removeClass("disabled");
    }
  
	/*get optimal bar for options*/
	var barW = $('#hang-bar img').width();
	var contentW = $('#content-line').outerWidth();

 	heightClass = localStorage.getItem('heightClass');
	var normalRatio = parseFloat(contentW * 100 / barImgageWidthRatio[heightClass]).toFixed(2);
	var barWidth = 0;
	var barWidthPx = 0;
	var checked = false;
 	var barWidthByValue = selectedWidth;
  
	$('._inaltimeSuport').addClass('disabled');
	$('._inaltimeSuport').removeClass('active');
	$('._inaltimeSuport_'+parseInt(barWidthHeightNewValues[parseInt(barWidthByValue)])).removeClass('disabled');
	$('._inaltimeSuport_'+parseInt(barWidthHeightNewValues[parseInt(barWidthByValue)])).addClass('active');

	// WSA set U.M. for _inaltimeSuport
	displaySelectedUM("#hangerH_8", 8);
	displaySelectedUM("#hangerH_11", 11);
	displaySelectedUM("#hangerH_115", 11.5);
	
	/*get min bar width*/
	$.each(barImageWidth, function(i, v){
		if(selectedWidth > -1 && selectedWidth == i && v >= contentW){
			checked = true;
			barWidth = barImageWidthCm[i];
			barWidthPx = v;
		}
	});
	if(checked === false){

		$.each(barImageWidth, function(i, v){
			if(v >= contentW && checked === false){
				barWidth = barImageWidthCm[i];
				barWidthPx = v;
				
				checked = true;
				click = false;
			}
		});
	}
  
//  WSA rebuild option description field
	rebuildOptionsDescription();

}
	
	
//ADD MODEL
$('.figure-add').click(function() {
	var image = $(this).html();
	var imageName = $(this).attr('data-value');
	var imageDataName = $(this).attr('data-name');
	figcnt++;

  $('.items-group').append('<li class="fig-added item'+figcnt+' fig"  id="fig'+figcnt+'"><a href="javascript:void(0)" class="btn-remove removeImg" data-class="item'+figcnt+'"><i class="fa fa-close"></i></a><div><a href="#" class="btn-reorder"><i class="fa fa-arrows"></i></a><p class="imgTag'+figcnt+'">' + image + '</p><input type="hidden" id="imgValue'+figcnt+'" value="'+imageName+'" /></div></li>');
	$('.empty-content').remove();
	rebuildTop();
});

//REMOVE MODEL
$(document).on('click','.removeImg',function() {
	var elRemove = $(this).attr('data-class');
 	$('.'+elRemove).remove();
	rebuildTop();
});

//ADD TEXT
var elem = '<span class="text-block one-five"></span>';

$('#content-line').append($(elem));
$('#one-fig-len').append($(elem));


$("#add-text-btn").click(function () {
	figcnt++;
	var itext = $('.quickkey').val();
  	if (!itext.trim()) {
      // is empty or whitespace
      $('.quickkey').focus();
      $(".quickkey").fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
	}
  else {
	var istyle = $('.textFont:checked').val();
  
	$('.items-group').append(textElement(figcnt, itext, istyle));
	$('.quickkey').val('');
	$('.empty-content').remove();
	rebuildTop();
  }
});

//EDIT TEXT
$(document).on('keyup', '.edit-txt', function(){
	rebuildTop();
});

//REMOVE TEXT
$(document).on('click','.removeTxt',function() {
	var elRemove = $(this).attr('data-class');
 	$('.'+elRemove).remove();
	rebuildTop()
});

function textElement(index, text, style) {
	return '<li class="fig-added text item'+index+' " id="text'+index+'"><a href="javascript:void(0)" class="btn-remove removeTxt" data-class="item'+index+' "><i class="fa fa-close"></i></a><div><a href="#" class="btn-reorder"><i class="fa fa-arrows"></i></a><input type="text" class="edit-txt " id="txtItem'+index+'" value="'+text+'"><input value="'+style+'" type="hidden" id="txtStyle'+index+'" class="txtStyle'+index+' exit-txt-style" /></div></li>'
}

function getSelectedProductDetails(){
	
  var barWidthByValue = localStorage.getItem('selectedWidth') == null ? "35" : localStorage.getItem('selectedWidth');
		
	var inaltimeContinut = $('#_inaltimeSuport').val();
	var latimeSuport = parseInt(barWidthValues[parseInt(barWidthByValue)]);
	var numarBareStr = localStorage.getItem('selectedBars');

 	var numarBareInt = numarBareStr==null ? 1 : numarBareStr.charAt(0); // assume first char is int
	var numarBare = barValueByNumber[parseInt(numarBareInt)];

 	var heightClass = heightClassByWidth[barWidthByValue];
	var heightClassName = heightClass;//+"_"+barWidthByValue;
	
	inaltimeContinut = $('._inaltimeSuport_'+parseInt(barWidthHeightNewValues[parseInt(barWidthByValue)])).attr('data-option');
		
		$('._inaltimeSuport').removeClass('active');
		
		$('#_inaltimeSuport').val(inaltimeContinut);
 		localStorage.setItem('heightClass', heightClassName);
  
		$('.viewItem').removeClass('one-five').removeClass('two').removeClass('two-five').removeClass('three').addClass(heightClassName);

		var contendHeight = 0;
		var barCount = 0;
		var barWidth = 0;
		var barWidthPx = 0;
		$('._inaltimeSuport').each(function(){
			if($(this).attr('data-option') == inaltimeContinut){
				$(this).addClass('active');
				contendHeight = $(this).attr('data-value');
			}
		});
 		// WSA U.M.
		displaySelectedUM("#barWidthSize", barWidthByValue);

		rebuildTop();
		var checked = false;
		/*get min bar width*/
		
		$.each(barImageWidthCm, function(i, v){
			if(v >= barWidthByValue && checked === false){
				barWidth = barImageWidthCm[i];
				barWidthPx = v;
				checked = true;
			}
		});
		
		// WSA set current variant image
		var imgSrc = localStorage.getItem('selectedBarImage');
		if (imgSrc != null) {
			$('.barImage').attr('src', imgSrc);
		}
}
$(document).ready(function(){
    /*remove disabled heights*/
	$('._inaltimeSuport').click(function(){
		if(!$(this).hasClass('disabled')){
			$('#_inaltimeSuport').val($(this).attr('data-option'));
			$('._inaltimeSuport').removeClass('active');
			$(this).addClass('active');
			getSelectedProductDetails();
		}
	});
  
  $("#reset-elems").click(function(){
    var elems = new Array();
    localStorage.setItem("addedElems", JSON.stringify(elems));
    $('.items-group').empty();
	$('.single-option-selector:eq(0)').val("35").trigger('change');
    $('.single-option-selector:eq(1)').val("1 bar").trigger('change');
  });

})  
// })( jQuery );